module.exports = __webpack_public_path__ + "/img/SOT23-DsoeIc.svg";